import { useQuery } from '@tanstack/react-query';
import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import { teamApi } from '@/services/api';

interface CommandPermissionsTableProps {
  teamId: string;
}

export default function CommandPermissionsTable({ teamId }: CommandPermissionsTableProps) {
  const { data: commandPermissions } = useQuery({
    queryKey: ['team-command-permissions', teamId],
    queryFn: () => teamApi.getCommandPermissions(teamId).then((res) => res.data),
    enabled: !!teamId,
  });

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Command</TableCell>
            <TableCell>Allowed Roles</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {commandPermissions?.map((perm) => (
            <TableRow key={perm.id}>
              <TableCell>
                <Typography variant="body2" fontFamily="monospace">
                  /{perm.command}
                </Typography>
              </TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                  {perm.allowed_roles.map((role, i) => (
                    <Chip
                      key={i}
                      label={role}
                      size="small"
                      variant="outlined"
                      color={
                        role === 'admin' ? 'error' :
                        role === 'team_lead' ? 'warning' :
                        'default'
                      }
                    />
                  ))}
                </Box>
              </TableCell>
              <TableCell>
                <Chip
                  label={perm.is_enabled ? 'Enabled' : 'Disabled'}
                  color={perm.is_enabled ? 'success' : 'default'}
                  size="small"
                />
              </TableCell>
            </TableRow>
          ))}
          {commandPermissions?.length === 0 && (
            <TableRow>
              <TableCell colSpan={3} align="center">
                No command permissions configured yet. Default permissions apply.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
